import   React         , 
       { useState      } from "react";

import   styles          from "./DateTimeRangePicker.module.scss";

import   FieldCalendar   from './FieldCalendar';
import   Trigger         from '../actuators/Trigger';


interface DateTimeRangePickerProps {
  onChange       : (start: string, end: string) => void;
  showHourPanel? : boolean;
  labelColor?    : string; 
  startDate?     : string;
  endDate?       : string;
  showButton?    : boolean
}

export const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({ onChange, 
                                                                          showHourPanel = false     ,
                                                                          labelColor    = "#000000" , 
                                                                          startDate                 ,
                                                                          endDate                   ,
                                                                          showButton    =  true     }) => {
                                                                              
  const [ currentStartDateTime , setCurrentStartDateTime ] = useState<string>(startDate ?? "");
  const [ currentEndDateTime   , setCurrentEndDateTime   ] = useState<string>(endDate ?? "");

  const handleCurrentStartDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setCurrentStartDateTime(event.target.value);
    
    if ( !showButton )
     {
      onChange(event.target.value, currentEndDateTime);
     }
  };

  const handleCurrentEndDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    setCurrentEndDateTime(event.target.value);

    if ( !showButton )
     {
      onChange(currentStartDateTime, event.target.value);
     }
  };

  const handleButtonClick = () => {
    onChange(currentStartDateTime, currentEndDateTime);
  };

  return (
    <div className = {styles.dateTimeRangePicker}>
      <div className = {styles.fieldWrapper}>
        <span className = {styles.label} 
              style     = {{ color: labelColor }}>Du&nbsp;:&nbsp;</span>
          <FieldCalendar value      = {currentStartDateTime}
                         onChange   = {handleCurrentStartDateTimeChange}
                         showHours  = {showHourPanel}
                         checkInput = {false}
                         dateFormat = {showHourPanel ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}  />
      </div>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <div className = {styles.fieldWrapper}>
        <span className = {styles.label} 
              style     = {{ color: labelColor }}>au&nbsp;:&nbsp;</span>
          <FieldCalendar value      = {currentEndDateTime}
                         onChange   = {handleCurrentEndDateTimeChange}
                         showHours  = {showHourPanel}
                         checkInput = {false}
                         dateFormat = {showHourPanel ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}  />               
      </div>
      {
       showButton &&
       (
        <>
         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
         <Trigger name="Rafraîchir" onClick={handleButtonClick} variant="tailwind2" />
        </>
       )
      }
    </div>
  );
};

export default DateTimeRangePicker;
